module.exports = __webpack_public_path__ + "6b1073ce.png";